"use client";

import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import brandApplication from "@faire/web-api--source/routes/www/apply";
import brands from "@faire/web-api--source/routes/www/brands";
import React from "react";
import { useLocation } from "react-router-dom";

import { HeaderLink } from "../styled";

export const SellOnFaireLink = () => {
  const location = useLocation();
  return (
    <HeaderLink
      to={location.pathname.includes(brands()) ? brandApplication() : brands()}
    >
      <StrictLocalMsg defaultMessage="Sell on Faire" />
    </HeaderLink>
  );
};
